import React from 'react';

import {Layout} from 'commons/models';
import {GeolocationInfo, ModuleItem} from 'commons/types/Types';

export type EfeMenuContextType = {
    menu: ModuleItem[];
    personType: string;
    foreign: boolean;
    layout: Layout;
    kycId: number;
    expedientId: number;
    fatherKycId: number;
    updateMenu: (data: ModuleItem[]) => void;
    setPersonType: (type: string) => void;
    setForeign: (value: boolean) => void;
    updateLayout: (data: Layout) => void;
    setKycId: (kycId: number) => void;
    setExpedientId: (expedientId: number) => void;
    setFatherKycId: (fatherKycId: number) => void;
    resetMenuProvider: () => void;
    geolocationData: GeolocationInfo;
    setGeolocationData: (value: GeolocationInfo) => void;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const OnboardingMenuContext = React.createContext<EfeMenuContextType>();

export function useMenuContext() {
    return React.useContext(OnboardingMenuContext);
}

export default OnboardingMenuContext;
